import { render, staticRenderFns } from "./freeSend.vue?vue&type=template&id=00d0597a&scoped=true"
import script from "./freeSend.vue?vue&type=script&lang=js"
export * from "./freeSend.vue?vue&type=script&lang=js"
import style0 from "./freeSend.vue?vue&type=style&index=0&id=00d0597a&prod&scoped=true&lang=css"
import style1 from "./freeSend.vue?vue&type=style&index=1&id=00d0597a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d0597a",
  null
  
)

export default component.exports